import React, { useState } from 'react';
import ViewMore from '../../pages/Inventory/ViewMore';
import { observer } from 'mobx-react';


const ViewMoreContainer = ({ closeModal }) => {
	const [openViewMoreModal, setOpenViewMoreModal ] = useState(true);
	const [ newEditModal, setNewEditModal] = useState(false);

	const handleCancel = () => {
		setOpenViewMoreModal(false);
	};

	const createNewEditModal = () => {
		setNewEditModal(true);
	};

	const goBack = () => {
		if (newEditModal) {
			setNewEditModal(false);
		} else closeModal()
	}

    return (
        <ViewMore
        closeModal={closeModal}
        goBack={goBack}
        handleCancel={handleCancel}
		newEditModal={newEditModal}
		createNewEditModal={createNewEditModal}
        />
    )
}

export default observer(ViewMoreContainer);